const API_TYPES = {
  GET: 'GET',
  DELETE: 'DELETE',
  PATCH: 'PATCH',
  POST: 'POST',
};

const CHANNEL_API_URL = '/gx/api/channels/inboxes';

const CREATE_CHANNELS_INBOXES = {
  type: API_TYPES.POST,
  url: CHANNEL_API_URL,
};

const DELETE_PARTICULAR_CHANNELS_INBOX = {
  type: API_TYPES.DELETE,
  url: CHANNEL_API_URL,
};

const GET_CHANNELS_INBOXES = {
  type: API_TYPES.GET,
  url: CHANNEL_API_URL,
};

const PATCH_CHANNELS_INBOXES = {
  type: API_TYPES.PATCH,
  url: CHANNEL_API_URL,
};

const UPDATE_CHANNELS_INBOX = {
  type: API_TYPES.PATCH,
  url: CHANNEL_API_URL,
};

const GET_UG_USERS = {
  type: API_TYPES.GET,
  url: '/api/settings/users',
  limit: 300,
  index: 0
};

const CHANNEL_API_ERROR = {
  message: 'Something went wrong',
  type: 'error'
};

const PATCH_SUCCESS = {
  message: 'General settings updated',
  type: 'success'
}

const WHATSAPP_API_ERROR = {
  message: 'Try again or reach out to support@hiverhq.com if issue persists.',
  type: 'error'
};

const WHATSAPP_PARAM_ERROR = {
  message: 'Some of the information entered is incorrect. Please try again.',
  type: 'error'
}

const WA_CREATE_GS = 'WA_inbox_created';

export {
  CREATE_CHANNELS_INBOXES,
  DELETE_PARTICULAR_CHANNELS_INBOX,
  GET_CHANNELS_INBOXES,
  UPDATE_CHANNELS_INBOX,
  GET_UG_USERS,
  CHANNEL_API_ERROR,
  WHATSAPP_API_ERROR,
  WHATSAPP_PARAM_ERROR,
  WA_CREATE_GS,
  PATCH_CHANNELS_INBOXES,
  PATCH_SUCCESS
};